import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as common from '../../../../../../../../common'
import * as enums from '../../../../../enums'
import * as account from '../account'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: account.RESOURCE.payload.dimension.partialId,
      partialId: account.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: common.MtdcCategory.NonSalary,
    description:
      'How is this expense type related to salaries & wages, if at all?',
    isOptional: false,
    name: 'MTDC Category',
    partialId: PartialId.Standard.create('mtdc_cat'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.mtdcCategory.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
